const map = {
	"./Aguascalientes.json": 9745,
	"./Baja_california.json": 2143,
	"./Baja_california_sur.json": 5569,
	"./Campeche.json": 138,
	"./Chiapas.json": 5199,
	"./Chihuahua.json": 5750,
	"./Ciudad_de_mexico.json": 1744,
	"./Coahuila.json": 4114,
	"./Colima.json": 635,
	"./Durango.json": 2950,
	"./Guanajuato.json": 9019,
	"./Guerrero.json": 9729,
	"./Hidalgo.json": 8998,
	"./Jalisco.json": 8057,
	"./Mexico.json": 1695,
	"./Michoacan.json": 4553,
	"./Morelos.json": 4385,
	"./Municipio.json": 6749,
	"./Nacional.json": 5581,
	"./Nayarit.json": 3742,
	"./Nuevo_leon.json": 2102,
	"./Oaxaca.json": 5267,
	"./Puebla.json": 7367,
	"./Queretaro.json": 6044,
	"./Quintana_roo.json": 436,
	"./San_luis_potosi.json": 7993,
	"./Sinaloa.json": 7239,
	"./Sonora.json": 3444,
	"./Tabasco.json": 1709,
	"./Tamaulipas.json": 5325,
	"./Tlaxcala.json": 3126,
	"./Veracruz.json": 9694,
	"./Yucatan.json": 3209,
	"./Zacatecas.json": 1711
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6191;